import { envVar } from '@env'
import { User } from '@features/auth/auth-client-adapter'
import { Organization } from '@st/sdk'
import { Effect } from 'effect'
import type { SupportChatLauncherConfig } from '~/effects/support-chat'
import { AnalyticsProvider } from '../core'
import { callIntercom } from './intercom-bootstrap'

interface IntercomAnalyticsProvider extends AnalyticsProvider {
  configureLauncher(config: SupportChatLauncherConfig): Effect.Effect<void>
}

function callConfiguredIntercom(method: string, ...args: unknown[]) {
  const intercomAppId = envVar('NEXT_PUBLIC_INTERCOM_APP_ID')
  return intercomAppId ? callIntercom(intercomAppId, method, ...args) : Effect.void
}

export const IntercomAnalyticsService: IntercomAnalyticsProvider = {
  configureLauncher: (config) =>
    callConfiguredIntercom('update', {
      hide_default_launcher: !config.visible,
      horizontal_padding: config.right,
      vertical_padding: config.bottom
    }),
  trackUserIdentified(user: User, { sdk }) {
    return Effect.gen(function* () {
      const unavailable = (error: unknown) =>
        Effect.logWarning('Intercom identity unavailable', error).pipe(Effect.as(null))
      const resp = yield* sdk.send({ type: 'accounts/getIntercomIdentity' }).pipe(
        Effect.catchTags({
          TransportError: unavailable,
          TimeoutError: unavailable,
          HttpStatusError: unavailable
        }),
        Effect.orDie
      )
      if (!resp) return

      yield* callConfiguredIntercom('update', {
        user_id: user.id,
        user_hash: resp.hash,
        name: user.name,
        email: user.email
      })
    })
  },
  setOrganization(organization: Organization) {
    return callConfiguredIntercom('update', {
      company: {
        id: organization.id,
        name: organization.name,
        plan: undefined,
        slug: organization.slug
      }
    })
  }
}
